import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button, Image } from "react-bootstrap";
import Header from "../../header/Header";
import Footer from "../../footer/Footer";
import Loader from "../../loader/Loader";
import PlanCard from "../../plans/PlanCard-lg";
import reference4Image from "../../../assets/images/index/Reference 4.jpg";
import reference5Image from "../../../assets/images/index/Reference 5.jpg";
import reference6Image from "../../../assets/images/index/Reference 6.jpg";

const Plan = () => {
  const [key, setKey] = useState("yearly");
  const [accountPlanData, setAccountPlanData] = useState([]);

  const [loading, setloading] = useState(true);
  useEffect(() => {
    document.title = "Plans & Pricing | Elderly Life";
    const apiUrl =
      "https://developmentapi.elderlylife.com/accountPlan/plan/list";

    fetch(apiUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json(); // Convert response to JSON
      })
      .then((data) => {
        // Modify the AccountPlanData array before setting it
        const updatedPlanData = data.AccountPlanData.map((plan) => {
          if (plan.renewalType === "yearly") {
            switch (plan.uniqueIdentifier) {
              case "single-yearly":
                return { ...plan, monthlyPrice: "4.17" };
              case "couple-yearly":
                return { ...plan, monthlyPrice: "5.83" };
              case "family-yearly":
                return { ...plan, monthlyPrice: "7.50" };
              default:
                return plan;
            }
          }
          return plan;
        });

        // Set the modified data
        setAccountPlanData(updatedPlanData);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
    setTimeout(() => {
      setloading(false);
    }, 500);
  }, []);

  return (
    <>
      <Header />
      {loading ? (
        <Loader />
      ) : (
        <>
          <Container>
            <div className="bg-primary-light rounded-3 p-6 p-md-10 p-xl-11 p-xxl-13 p-xxxl-14 mb-5">
              <Row className="justify-content-center mb-6 mb-md-7 mb-xl-8 mb-xxxl-9">
                <Col xxxl="24">
                  <h1 className="h2 text-center mb-4 mb-md-5">
                    Simple Support For Everyday Life
                  </h1>
                  <p className="lead text-center text-dark mb-0">
                    A calm, simple way to stay organised, supported and connected — whether for yourself or someone you care about.
                  </p>
                </Col>
              </Row>
              <div className="d-flex justify-content-center mb-6 mb-md-7 mb-xl-8 mb-xxxl-9">
                <div className="border bg-white rounded-2 d-flex gap-1 p-2">
                  {/* <Button variant="primary">Annual (save 37%)</Button> */}
                  {/* <Button variant="light">Monthly</Button> */}
                  <button
                    className={`btn rounded-2 ${
                      key !== "monthly" ? "btn-primary" : ""
                    }`}
                    onClick={() => setKey("yearly")}
                  >
                    Pay Annually & Save
                  </button>
                  <button
                    className={`btn rounded-2 ${
                      key === "monthly" ? "btn-primary" : ""
                    }`}
                    onClick={() => setKey("monthly")}
                  >
                    Pay Monthly
                  </button>
                </div>
              </div>
              <Row className="justify-content-center align-items-stretch gy-5 pb-5 pb-md-9 pb-xl-10 pb-xxxl-11">
                {accountPlanData &&
                  accountPlanData
                    .filter((item) => item.renewalType === key)
                    .map((item) => (
                      <Col className="col-24 col-md-13 col-xl-8 col-xxl-7 col-xxxl-6">
                        <PlanCard planType={item} keyType={item.renewalType} />
                      </Col>
                    ))}
              </Row>
              <div className="text-center">
                {/* <div class="lead mb-1">&#x1F642;</div> */}
                <p className="text-info fw-semibold mb-0">
                  No pressure, no commitments, just 30 days to discover how
                  Elderly Life can support you or someone you care for.​
                </p>
              </div>
            </div>
          </Container>
          <section className="py-10 pb-11 pb-md-12 pb-xl-13 pb-xxxl-14 border-top">
            <Container>
              <div className="text-center mb-9 mb-md-10">
                <h2 className="mb-3">
                  No hidden costs. No pressure. Cancel anytime.
                </h2>
                <p className="lead text-dark mb-0">
                  We're here to help you feel more organised and supported — every step of the way.
                </p>
              </div>
              <Row className="justify-content-between gx-xxl-0 align-items-stretch">
                <Col xl="12" xxl="11" xxxl="10" className="order-2 order-xl-1 mt-5 mt-xl-0">
                  {/* Main User Section */}
                  <section className="mb-8">
                    <h3 className="font-bold mb-4 h5">Main User</h3>
                    <p className="small text-dark mb-3">
                      The Main User is the person being supported, usually an older adult managing everyday life, reminders, paperwork, accounts, or important tasks.
                    </p>
                    <p className="small text-dark fw-bold mb-2">
                      Stay organised with reminders, tasks, and life admin
                    </p>
                    <ul className="small text-dark mb-5">
                      <li>Choose what information to add to your platform</li>
                      <li>Invite trusted family, friends, or carers for support</li>
                      <li>Can also support someone else within the same plan</li>
                    </ul>
                  </section>

                  {/* Support User Section */}
                  <section className="mb-8">
                    <h3 className="font-bold mb-4 h5">Support User</h3>
                    <p className="small text-dark mb-3">
                      A Support User is someone trusted to help, such as a partner, son, daughter, family member, friend, or carer.
                    </p>
                    <p className="small text-dark fw-bold mb-2">They can:</p>
                    <ul className="small text-dark mb-5">
                      <li>Help manage reminders and shared tasks</li>
                      <li>Assist with everyday organisation when needed</li>
                      <li>Step in quietly before important things are missed</li>
                      <li>Support one or multiple Main Users</li>
                    </ul>
                  </section>

                  {/* Shared Support, Your Way */}
                  <section>
                    <h3 className="font-bold mb-4 h5">Shared Support, Your Way</h3>
                    <p className="small text-dark mb-3">
                      Support works both ways.
                    </p>
                    <p className="small text-dark fw-bold mb-2">For example:</p>
                    <ul className="small text-dark mb-4">
                      <li>Mum can be a Main User supported by Dad and their Son</li>
                      <li>Dad can also be a Main User supported by Mum and their Daughter</li>
                      <li>Couples can support one another together</li>
                      <li>Families can stay connected and organised together, even across different households</li>
                      <li>Support doesn't have to live under the same roof.</li>
                    </ul>
                    <p className="small text-dark mb-0">
                      Elderly Life is built around collaboration, reassurance, and everyday support, without taking independence away.
                    </p>
                  </section>
                </Col>
                <Col xl="11" xxl="11" className="offset-xl-1 order-1 order-xl-2">
                  <div style={{ position: "sticky", top: "2rem" }}>
                    <div className="w-100 rounded-4 shadow-sm border overflow-hidden" style={{ position: "relative", paddingTop: "56.25%", height: 0 }}>
                      <iframe
                        src="https://player.vimeo.com/video/1204543922?title=0&byline=0&portrait=0&badge=0&autopause=0"
                        frameBorder="0"
                        allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                        style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}
                        title="Pricing Video"
                      ></iframe>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>

          <Footer />
        </>
      )}
    </>
  );
};

export default Plan;
